var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pointer h30",on:{"click":_vm.openSw}},[(_vm.active)?_c('div',[_c('img',{staticStyle:{"width":"40px"},attrs:{"src":require("@/assets/images/kaiguankai.png")}})]):_vm._e(),_vm._v(" "),(!_vm.active)?_c('div',[_c('img',{staticStyle:{"width":"40px"},attrs:{"src":require("@/assets/images/kaiguanguan.png")}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1558632a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/Switch.vue
// module id = null
// module chunks = 